module.exports = __webpack_public_path__ + "static/img/7.991c261.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/7.png
// module id = WNvK
// module chunks = 0